import { API_URL } from "env";
import { AccountLiveTrade, AccountReport, LiveTradingResponse } from "./type";

async function getAccountLiveTrade(accountNumber: string, page: number, limit: number): Promise<LiveTradingResponse | undefined> {
    try {
        const response = await fetch(`${API_URL}/api/v1/live-trading?account_number=${accountNumber}&limit=${limit}&page=${page}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
        });
        if (!response.ok) {
            return {
                    status: true,
                    data: {
                        current_page: 0,
                        data: [],
                        first_page_url: '',
                        from: 0,
                        last_page: 0,
                        last_page_url: '',
                        links: [],
                        next_page_url: null,
                        path: '',
                        per_page: 0,
                        prev_page_url: null,
                        to: 0,
                        total: 0,
                    },
                    msg: 'Error fetching live trade data',
            };
        }
        const data: LiveTradingResponse = await response.json();
        return data;
    } catch (error) {
        console.log(error);
        throw new Error("Failed to fetch account live trade data");
    }
}

async function getAccountReport(accountNumber: string, dateFrom?: string, dateTo?: string): Promise<AccountReport | undefined> {
    try {
        const queryParams = new URLSearchParams();
        queryParams.append('account_number', accountNumber);
        if (dateFrom) {
            queryParams.append('date_from', dateFrom);
        }
        if (dateTo) {
            queryParams.append('date_to', dateTo);
        }
        const response = await fetch(`${API_URL}/api/v1/be/trade-history/reports?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
        });
        const data: AccountReport = await response.json();
        return data;
    } catch (error) {
        console.log(error);
        throw new Error("Failed to fetch account report data");
    }
}

export { getAccountLiveTrade, getAccountReport };